import { ButtonTranslucent, Colors, Icon } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { useOpenObjectiveCycles } from '../hooks/useOpenObjectiveCycles';

import { Permission } from '@/constants/Permission';
import { useUserPermissions } from '@/hooks/api/useUserPermissions';

/**
 * The actions band's shortcut to the "Objective periods" tab of the evaluation-cycles page. The
 * periods are administered by whoever manages every employee's objectives, so the button is
 * rendered only to those who hold that permission -- hidden, never disabled.
 */
export default function ObjectivePeriodsButton() {
    const { t } = useTranslation();
    const { can } = useUserPermissions();
    const openObjectiveCycles = useOpenObjectiveCycles();

    if (!can(Permission.ManageAllEmployeesObjectives)) {
        return null;
    }

    return (
        // The library's translucent pill, the prototype's own button over the glass band: a
        // secondary button restyled by classes kept its grey border, since the library joins its
        // classes after ours without merging them.
        <ButtonTranslucent
            onClick={openObjectiveCycles}
            size={'md'}
            leftIcon={
                <Icon
                    name={'time-calendar'}
                    size={'sm'}
                    color={Colors.PRIMARY}
                />
            }
            dataTestId={'objective-periods-button'}
        >
            {t('objectives.objectivePeriodsButton')}
        </ButtonTranslucent>
    );
}
